import React from 'react';

import { StyleSheet } from 'react-native';

import { InnerLayout } from 'components/layout/styled';
import { Box, BoxProps } from 'components/ui';

export const ProductComboFlowContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productComboFlowContainer, style]} />
);

export const ProductComboFlowInnerLayout = InnerLayout.withConfig({
  marginY: 0,
  paddingY: 0,
});

const styles = StyleSheet.create({
  productComboFlowContainer: {
    width: '100%',
  },
});
